<template>
  <div id="app">
    <router-view v-slot="{ Component, route }">
      <transition name="fade" mode="out-in">
        <component :is="Component" :key="route.path" />
      </transition>
    </router-view>

    <!-- DialerModal persists across all pages to receive calls -->
    <DialerModal ref="dialerModal" />
  </div>
</template>

<script>
import DialerModal from './components/DialerModal.vue'

export default {
  name: 'App',
  components: {
    DialerModal
  }
}
</script>

<style>
/* Route transition styles */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
